// Dependencies
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
/*eslint-disable */
import TimelineMax from 'gsap/TimelineMax';
import TweenLite from 'gsap/TweenLite';
import { Power4 } from 'gsap/easing/EasePack';
import 'gsap/plugins/CSSPlugin';
/*eslint-enable */
// Components
import Button from '../components/button';
// Actions
import setStep from '../actions/steps';
import shuffleQuotes from '../actions/quotes';
import setSnowflakesToExploded from '../actions/snowflakes';
import toggleTimeline from '../actions/timeline';
import { setTheme, shuffleThemes } from '../actions/themes';
// Data
import { QUOTE_QUANTITY } from '../constants/config';
// Assets
import mariahAudio from '../../audio/mariah.mp3';
import messiahAudio from '../../audio/messiah.mp3';
// Images
const pathToImages = require.context('../../images/cutouts', true);


class Question extends Component {
  constructor() {
    super();
    this.state = {
      answer: '',
      guess: ''
    };

    this.introTl = new TimelineMax({
      paused: true
    });
  }

  componentWillMount() {
    const { dispatch, themes } = this.props;
    dispatch(toggleTimeline(true));
    dispatch(shuffleQuotes());
    dispatch(setStep(0));
    dispatch(setTheme(themes[0]));
  }

  componentDidMount() {
    this.fireIntroAnimation();
  }

  componentWillUnmount() {
    // Shuffle themes incase of another round
    this.props.dispatch(shuffleThemes());
  }

  getName(id) {
    if (id === 'mariah') return 'Mariah';
    if (id === 'messiah') return 'Jesus';
  }

  fireIntroAnimation() {
    const tl = new TimelineMax({ delay: 0.6 });

    tl
      .from(this.$title, 1, { y: '20', opacity: 0 })
      .from(this.$quote, 1, { y: '20', opacity: 0 }, '-=0.75')
      .from(this.$messiah, 1, { clearProps: 'x, opacity', x: '50%', opacity: 0 })
      .from(this.$mariah, 1, { clearProps: 'x, opacity', x: '-50%', opacity: 0 }, '-=0.75')
      .from(this.$answerMessiah, 1, { clearProps: 'opacity', y: '20', opacity: 0 })
      .from(this.$answerMariah, 1, { clearProps: 'opacity', y: '20', opacity: 0 }, '-=0.75');
  }

  fireChosenAnimation(answer) {
    const { quotes, currentStep } = this.props;

    const tl = new TimelineMax();

    tl.set(this.$answer, { opacity: 0 });
    tl.set(answer === 'messiah' ? this.$mariah : this.$messiah, { opacity: 0.2 });

    if (quotes[currentStep].attribution === 'mariah') {
      tl.to(this.$messiah, 1, { x: '62%', opacity: 0, scale: '1', ease: Power4.easeInOut });
      tl.to(this.$mariah, 1, { x: '50%', opacity: 1, scale: '1.05', ease: Power4.easeInOut }, '-=1');
    } else {
      tl.to(this.$messiah, 1, { x: '-62%', opacity: 1, scale: '1.05', ease: Power4.easeInOut });
      tl.to(this.$mariah, 1, { x: '-50%', opacity: 0, scale: '1', ease: Power4.easeInOut }, '-=1');
    }

    tl.to(this.$answerMariah, 0.3, { opacity: 0, overwrite: 'all' }, '-=1');
    tl.to(this.$answerMessiah, 0.3, { opacity: 0, overwrite: 'all' }, '-=1');

    tl.to(this.$quote, 1, { delay: 0.4, opacity: 0.4 }, '-=1.4');
    tl.to(this.$answer, 0.6, { opacity: 1 }, '-=0.8');
  }

  fireLeaveAnimation(tl) {
    const { quotes, currentStep } = this.props;

    if (quotes[currentStep].attribution === 'mariah') {
      tl.to(this.$mariah, 0.6, { opacity: 0 });
    } else {
      tl.to(this.$messiah, 0.6, { opacity: 0 });
    }
  }

  fireResetAnimation() {
    // We have to do that because some elements are removed
    // from the DOM cause of React and also because we do
    // animations in 2 differents timelines
    TweenLite.set(this.$title, { y: '0', opacity: 1 });
    TweenLite.set(this.$quote, { y: '0', opacity: 1 });
    TweenLite.set(this.$messiah, { x: '0%', scale: 1, opacity: 1 });
    TweenLite.set(this.$mariah, { x: '0%', scale: 1, opacity: 1 });
    TweenLite.set(this.$answerMessiah, { y: '0', opacity: 1 });
    TweenLite.set(this.$answerMariah, { y: '0', opacity: 1 });

    this.fireIntroAnimation();
  }

  fireAudio() {
    const { quotes, currentStep } = this.props;

    if (this.props.audio) {
      if (quotes[currentStep].attribution === 'messiah') {
        this.$messiahAudio.play();
      } else {
        this.$mariahAudio.play();
      }
    }
  }

  handleSubmit(answer) {
    const { quotes, currentStep } = this.props;
    this.fireAudio(answer);
    this.fireChosenAnimation();
    this.setState({ answer });
    this.fireChosenAnimation(answer);
    if (answer === quotes[currentStep].attribution) {
      this.props.dispatch(setSnowflakesToExploded(true));
    }
  }

  progressGame = () => {
    const { dispatch, currentStep, themes } = this.props;
    const tl = new TimelineMax();

    this.fireLeaveAnimation(tl);
    this.props.dispatch(setSnowflakesToExploded(false));

    tl.call(() => {
      dispatch(setSnowflakesToExploded(false));

      if (currentStep < QUOTE_QUANTITY - 1) {
        dispatch(setStep(currentStep + 1));
        dispatch(setTheme(themes[currentStep + 1]));
        this.setState({ answer: '', guess: '' });
        this.fireResetAnimation();
      } else {
        this.props.router.push('/complete');
      }
    }, null, this, '+=0.4');
  }

  handleGuess(guess) {
    if (this.state.answer) return;

    this.setState({ guess });

    if (guess === 'mariah') {
      TweenLite.to(this.$mariah, 0.4, { scale: '1.05', ease: Power4.easeInOut });
      TweenLite.to(this.$messiah, 0.4, { scale: '1', ease: Power4.easeInOut });
    } else if (guess === 'messiah') {
      TweenLite.to(this.$mariah, 0.4, { scale: '1', ease: Power4.easeInOut });
      TweenLite.to(this.$messiah, 0.4, { scale: '1.05', ease: Power4.easeInOut });
    } else {
      TweenLite.to(this.$mariah, 0.4, { scale: '1', ease: Power4.easeInOut });
      TweenLite.to(this.$messiah, 0.4, { scale: '1', ease: Power4.easeInOut });
    }
  }

  render() {
    const { answer, guess } = this.state;
    const { audio, currentStep, quotes, currentTheme } = this.props;
    const quote = quotes[currentStep] || ' ';
    return (
      <div className="view view--question">
        <h1
          className={`h3 gradient-text gradient-text--${currentTheme}`}
          ref={ref => this.$title = ref}
        >
          Who said it?
        </h1>
        {quote && <h2 ref={ref => this.$quote = ref} className="h2">&ldquo;{quote.quote}&rdquo;</h2>}
        <div className="question">
          <p className="h1 question__answer" ref={ref => this.$answer = ref}>
            {answer && answer === quote.attribution &&
              <span>
                Congratulations, that was&nbsp;
                <span className={`gradient-text gradient-text--${currentTheme}`}>
                  {this.getName(quote.attribution)}!
                </span>
              </span>
            }
            {answer && answer !== quote.attribution &&
              <span>
                Sorry, that was&nbsp;
                <span className={`gradient-text gradient-text--${currentTheme}`}>
                  {this.getName(quote.attribution)}
                </span>
              </span>
            }
          </p>

          <div className="question__answers">
            <button
              ref={ref => this.$answerMariah = ref}
              onClick={this.handleSubmit.bind(this, 'mariah')}
              onMouseEnter={this.handleGuess.bind(this, 'mariah')}
              onMouseLeave={this.handleGuess.bind(this, '')}
              className={classNames(`button--answer gradient-text-hover gradient-text-hover--${currentTheme}`, {
                'gradient-text-hover--active': guess === 'mariah',
                'gradient-text-hover--disabled': guess === 'messiah',
                'button--disabled': answer
              })}
              data-title="Mariah"
            >
              Mariah
            </button>
            <button
              ref={ref => this.$answerMessiah = ref}
              onClick={this.handleSubmit.bind(this, 'messiah')}
              onMouseEnter={this.handleGuess.bind(this, 'messiah')}
              onMouseLeave={this.handleGuess.bind(this, '')}
              className={classNames(`button--answer gradient-text-hover gradient-text-hover--${currentTheme}`, {
                'gradient-text-hover--active': guess === 'messiah',
                'gradient-text-hover--disabled': guess === 'mariah',
                'button--disabled': answer
              })}
              data-title="Messiah"
            >
              Messiah
            </button>
          </div>
        </div>
        {answer &&
          <Button
            className="button--bottom-center"
            onClick={this.progressGame}
          >
            Next
          </Button>
        }
        <picture>
          <source
            srcSet={pathToImages(`./mariah-${currentTheme}-@2x.svg`)}
            media="(min-height: 400px)"
          />
          <img
            ref={(ref) => this.$mariah = ref}
            src={pathToImages(`./mariah-${currentTheme}.svg`)}
            onClick={this.handleSubmit.bind(this, 'mariah')}
            onMouseEnter={this.handleGuess.bind(this, 'mariah')}
            onMouseLeave={this.handleGuess.bind(this, '')}
            className={classNames(`character character--mariah character--mariah-${currentTheme}`, {
              'character--active': guess === 'mariah',
              'character--inactive': guess === 'messiah',
              'character--disabled': answer
            })}
            alt="Mariah"
          />
        </picture>
        <picture>
          <source
            srcSet={pathToImages(`./messiah-${currentTheme}-@2x.svg`)}
            media="(min-height: 400px)"
          />
          <img
            ref={(ref) => this.$messiah = ref}
            src={pathToImages(`./messiah-${currentTheme}.svg`)}
            onClick={this.handleSubmit.bind(this, 'messiah')}
            onMouseEnter={this.handleGuess.bind(this, 'messiah')}
            onMouseLeave={this.handleGuess.bind(this, '')}
            className={classNames(`character character--messiah character--messiah-${currentTheme}`, {
              'character--active': guess === 'messiah',
              'character--inactive': guess === 'mariah',
              'character--disabled': answer
            })}
            alt="Messiah"
          />
        </picture>
        <audio src={messiahAudio} ref={ref => this.$messiahAudio = ref} />
        <audio src={mariahAudio} ref={ref => this.$mariahAudio = ref} />
      </div>
    );
  }
}

function mapStateToProps({ currentStep, audio, quotes, currentTheme, themes }) {
  return { currentStep, audio, quotes, currentTheme, themes };
}

export default withRouter(connect(mapStateToProps)(Question));



/** WEBPACK FOOTER **
 ** ./src/js/containers/question.js
 **/